import * as React from 'react';

import styled, { css } from 'styled-components';

export interface CrossIconProps {
  className?: string;
  size?: number;
  grey?: boolean;
  darkGrey?: boolean;
  onClick?: (ev: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const CrossIcon: React.FC<CrossIconProps> = (props) => (
  <svg
    viewBox="0 0 32 32"
    className={props.className}
    onClick={(ev) => (props.onClick ? props.onClick(ev) : null)}
  >
    <path
      className="background"
      d="M4 0h24c2.2 0 4 1.8 4 4v24c0 2.2-1.8 4-4 4H4c-2.2 0-4-1.8-4-4V4C0 1.8 1.8 0 4 0z"
    />
    <path
      className="cross"
      d="M19.8 12.2c0.3 0.3 0.3 0.7 0 1L17 16l2.9 2.9c0.3 0.3 0.3 0.7 0 1 -0.3 0.3-0.7 0.3-1 0L16 17l-2.9 2.9c-0.3 0.3-0.7 0.3-1 0 -0.3-0.3-0.3-0.7 0-1L15 16l-2.9-2.9c-0.3-0.3-0.3-0.7 0-1 0.3-0.3 0.7-0.3 1 0L16 15l2.9-2.9C19.1 11.9 19.5 11.9 19.8 12.2z"
    />
  </svg>
);

export default styled(CrossIcon)`
  width: ${(props) => (props.size ? props.size : '32')}px;
  height: ${(props) => (props.size ? props.size : '32')}px;
  &.circle {
    border-radius: 50%;
  }
  .background {
    ${(props) =>
      props?.darkGrey
        ? css`
            fill: ${({ theme }) => theme.colors.secondary};
          `
        : !props.grey
        ? `
      fill: #FBD6D7;
      opacity: .5;
    `
        : css`
            fill: ${({ theme }) => theme.colors.background};
          `}
  }

  .cross {
    ${(props) =>
      props.darkGrey
        ? css`
            fill: ${({ theme }) => theme.colors.primary};
          `
        : !props.grey
        ? css`
            fill: ${({ theme }) => theme.colors.error};
          `
        : css`
            fill: ${({ theme }) => theme.colors.primary};
          `}
  }
`;
